module.exports = __webpack_public_path__ + "ba6c6d7728e56330c4837d0c09c74578.MP3";